import Vue from 'vue'
import Router from 'vue-router'
import First from '@/components/first'
import A from '../components/page/a.vue'
import B from '../components/page/b.vue'
import C from '../components/page/c.vue'
import D from '../components/page/d.vue'
import E from '../components/page/e.vue'
import F from '../components/page/f.vue'
import G from '../components/page/g.vue'
import H from '../components/page/h.vue'
import K from '../components/page/k.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'First',
      component: First
    },
    {
      path: '/A',
      name: 'A',
      component: A
    },
    {
      path: '/B',
      name: 'B',
      component: B
    },
    {
      path: '/C',
      name: 'C',
      component: C
    },
    {
      path: '/D',
      name: 'D',
      component: D
    },
    {
      path: '/D',
      name: 'D',
      component: D
    },
    {
      path: '/E',
      name: 'E',
      component: E
    },
    {
      path: '/F',
      name: 'F',
      component: F
    },
    {
      path: '/G',
      name: 'G',
      component: G
    },
    {
      path: '/H',
      name: 'H',
      component: H
    },
    {
      path: '/K',
      name: 'K',
      component: K
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js